import axios from "axios";
import { Message } from "element-ui";
import md5 from "./md5";
import { getToken } from "./common";

const instance = axios.create({
  timeout: 10000,
});

function getHeaders() {
  const davinciKey = "davinci.xiaoyibang";
  const nonceStr = new Date().getTime() % 100000;
  const sign = md5(nonceStr + davinciKey);
  return { sign, nonceStr };
}

instance.interceptors.request.use(function(config) {
  const customHeaders = getHeaders();
  config.headers = {
    ...customHeaders,
    ...config.headers,
    requestTime: new Date().getTime(),
    token: getToken(),
  };
  return config;
});

instance.interceptors.response.use(
  function(res) {
    const { message, code, data } = res.data;
    if (code != "200") {
      Message.error(message);
      if (code == "401") {
        window.localStorage.clear();
        window.location.reload();
      }
      return Promise.reject(message);
    } else {
      return Promise.resolve(data);
    }
  },
  (err) => {
    Message.error("请求超时！");
    return Promise.reject(err);
  }
);

export default instance;
